import Mustache from 'mustache';
import { nanoid } from 'nanoid';

/**
 * Hydrate a question with the current mustache prompts
 * @param {Object} question - The question object to hydrate
 * @param {Object} mustachePrompts - The mustache prompts to use for hydration
 * @returns {Object} The hydrated question object
 */
export const hydrateQuestionWithPrompts = (question, mustachePrompts) => {
  if (!question) {
    return question;
  }

  const context = { prompt: mustachePrompts || {} };

  const hydrateString = (value) =>
    typeof value === 'string' ? Mustache.render(value, context) : value;

  const hydratedQuestion = {
    ...question,
    caption: hydrateString(question.caption),
    text: hydrateString(question.text),
  };

  if (Array.isArray(hydratedQuestion.answers)) {
    hydratedQuestion.answers = hydratedQuestion.answers.map((answer) => {
      if (answer && typeof answer === 'object') {
        return {
          ...answer,
          id: nanoid(),
          label: hydrateString(answer.label),
          text: hydrateString(answer.text),
        };
      }

      return answer;
    });
  }

  if (Array.isArray(hydratedQuestion.options)) {
    hydratedQuestion.options = hydratedQuestion.options.map((option) => {
      if (typeof option === 'string') {
        return hydrateString(option);
      }

      if (option && typeof option === 'object') {
        return {
          ...option,
          label: hydrateString(option.label),
          text: hydrateString(option.text),
        };
      }

      return option;
    });
  }

  return hydratedQuestion;
};
